<form
  [formGroup]="algemeneMeldingInputForm"
  (ngSubmit)="onSubmit()">

  <mat-form-field (click)="picker.open()"
    class="zichtbaarheidsperiode">
    <mat-label>Zichtbaar van - tot en met</mat-label>
    <mat-date-range-input [rangePicker]="picker">
      <input matStartDate formControlName="actiefVanDag" placeholder="Van">
      <input matEndDate formControlName="actiefTotDag" placeholder="tot en met">
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker">
    </mat-datepicker-toggle>
    <mat-date-range-picker #picker>
    </mat-date-range-picker>
    @if (actiefVanDag.hasError('required') || actiefTotDag.hasError('required')) {
      <mat-error>Verplicht</mat-error>
    }
  </mat-form-field>

  <mat-form-field class="content">
    <mat-label>Nieuwe melding</mat-label>
    <textarea matInput
      cdkTextareaAutosize
      cdkAutosizeMinRows="3"
      cdkAutosizeMaxRows="10"
      formControlName="content"
      type="textarea"
      [placeholder]="'Voer een nieuwe melding in'"
      (keydown.enter)="$event.stopPropagation()">
    </textarea>
    @if (content.hasError('notBlank')) {
      <mat-error>Verplicht</mat-error>
    }
  </mat-form-field>

  <div mat-dialog-actions
    class="buttons">
    <button
      mat-button
      color="primary"
      mat-dialog-close>
      Annuleer
    </button>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="algemeneMeldingInputForm.invalid">
      Bewaar
    </button>
  </div>
</form>
